var _defs, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-45573b55-68d2-48f5-9935-e755bf8b0045",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-15e75528-62f0-40b1-b332-0873a1701ab2 {\n        fill: #f2f2f2;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-15e75528-62f0-40b1-b332-0873a1701ab2",
    cx: 16,
    cy: 11.5,
    r: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-15e75528-62f0-40b1-b332-0873a1701ab2",
    d: "M18.24,22.95h-4.47c-1.19,0-2.15-.97-2.15-2.15v-3.02c0-1.19.97-2.15,2.15-2.15l.18.02c.66.12,1.74.29,2.06.29s1.4-.17,2.06-.29l.18-.02c1.19,0,2.15.97,2.15,2.15v3.02c0,1.19-.97,2.15-2.15,2.15ZM13.72,17.63c-.06.02-.11.08-.11.14v3.02c0,.08.07.15.15.15h4.47c.08,0,.15-.07.15-.15v-3.02c0-.07-.04-.12-.11-.14-.47.08-1.73.3-2.28.3s-1.81-.21-2.28-.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.18df7ee01ffcf18a6c51308342c4e25e.svg";
export { ForwardRef as ReactComponent };